import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import homeIcon from '@assets/images/header-home.svg'
import { DisabledWrapper } from '@components/DisabledWrapper'
import MainLogo from '@components/MainLogo'
import { useAuthContext } from '@modules/auth/hooks/useAuthContext'
import Link from '@mui/material/Link'
import { useFeatureFlags } from '@shared/hooks/useFeatureFlags'

import UserProfileSection from './UserProfileSection'
import { StyledHeader, UserProfileSectionWrapper } from './index.styles'

const Header = (props: { hidePendoGuideIcon?: boolean }) => {
  const { hidePendoGuideIcon } = props
  const { t } = useTranslation()
  const altHomeIconTxt = t(translationKeys.HEADER_HOME_ICON_ALT_TEXT) || ''
  const { user } = useAuthContext()
  const { hasUnlimitiedAccessToProfiles: hasAccessToP1Search } = useFeatureFlags()
  return (
    <StyledHeader data-testid="header">
      <DisabledWrapper disabled={!hasAccessToP1Search}>
        <Link href="/plus/search" underline="none" className="header-home-link">
          <img src={homeIcon} alt={altHomeIconTxt} data-testid="header-home-icon" />
          <MainLogo dataTestId="header-main-logo" />
        </Link>
      </DisabledWrapper>
      {user && (
        <UserProfileSectionWrapper>
          <UserProfileSection user={user} hidePendoGuideIcon={hidePendoGuideIcon} />
        </UserProfileSectionWrapper>
      )}
    </StyledHeader>
  )
}

export default Header
